module.exports = __webpack_public_path__ + "static/media/edukacja i hr.4bb03dac.svg";